/**
 * 简易的preload
 */

// 由于部分测试机型总是不能完全获得图片
// 因此写了这个简单的逻辑来统一加载图片
// 并且收集报错信息

function Preload(t, e) { 
    if (!util.isArray(t)) 
        throw new Error("pics must be an array type"); 
    this.pics = t,
    this.options = util.extend({}, this.constructor.defaultOptions, e), 
    this.index = this.failNum = 0, this.init();
    this.errors = [];
} 
let util = { 
    extend: function (t) { 
        for (var i = 1; i < arguments.length; i++) {
            for (var o in arguments[i]) {
                Object.prototype.hasOwnProperty.call(arguments[i], o) && (t[o] = arguments[i][o]);
            }
        }
            
        return t
    }, 
    isArray: function (t) { 
        return Array.isArray ? Array.isArray(t) : "[object Array]" == Object.prototype.toString.call(t) 
    }, 
    isValidListener: function (t) { 
        return "function" == typeof t || !(!t || "object" != typeof t) && this.isValidListener(t.listener) 
    }, 
    indexOf: function (t, e) { 
        if (t.indexOf) {
            return t.indexOf(e); 
        }
        for (var i = -1, o = 0, n = t.length; o < n; o++)
            if (t[o] === e) { 
                i = o; 
                break;
            }
        return i;
    } 
}; 
Preload.VERSION = "1.0.0", 
Preload.defaultOptions = { 
    complete: function () { }, 
    progress: function () { } 
}; 
var o = Preload.prototype; 
o.init = function () { 
    for (var t = 0; t < this.pics.length; t++)
        this.loadImg(this.pics[t]) 
};
o.loadImg = function (t) { 
    var e = this, i = new Image; 
    i.onload = function () { 
        i.onload = null, e.progress(t, "success")
    }, 
    i.onerror = function (err) {
        e.progress(t, "fail");
        e.errors.push([err, t]);
    }, 
    i.src = t
};
o.progress = function (t, e) { 
    "fail" == e && this.failNum++;
    this.index++;
    this.options.progress(this.index, this.pics.length, e);
    this.index === this.pics.length && this.options.complete(this.pics.length - this.failNum, this.failNum, this.errors);
};

export default Preload;


